// extracted by mini-css-extract-plugin
export default {"root":"JoinUsContent_root__y43sU"};